import React, { Fragment } from 'react';
import { useSelector } from "react-redux";
import { Menu, Transition } from '@headlessui/react';
import clsx from "clsx";

const LanguageSelectorMobile = () => {
    const languages = useSelector((state) => state.navigation.languages);

    if(languages.length < 2){
        return null;
    }

    const selectedLang = languages.find(x => x.selected);

    return (<div className={clsx("language-selector-mobile__wrapper")}>
        <Menu as="div" className={clsx("language-selector-mobile__menu")}>
            {({ open }) => (
                <>
                    <div>
                        <Menu.Button className="language-selector-mobile__button">
                            {
                                selectedLang.imageUrl && <img src={selectedLang.imageUrl} alt="" width={30} height={30}/>
                            }

                            {selectedLang.extendedText}
                            <svg className={"language-selector-mobile__arrow" + (open ? " language-selector-mobile__arrow--open" : "")}
                                 width="20" height="21" viewBox="0 0 20 21" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <g id="chevron-down">
                                    <path id="Vector" d="M5 7.68945L10 12.6895L15 7.68945"
                                          stroke="var(--footer-language-picker-arrow-color, #000000)"
                                          strokeWidth="2"
                                          strokeLinecap="round" strokeLinejoin="round"/>
                                </g>
                            </svg>

                        </Menu.Button>
                    </div>
                    <Transition
                        as={Fragment}
                        enter="language-selector-mobile__transition--enter"
                        enterFrom="language-selector-mobile__transition--enter-from"
                        enterTo="language-selector-mobile__transition--enter-to"
                        leave="language-selector-mobile__transition--leave"
                        leaveFrom="language-selector-mobile__transition--leave-from"
                        leaveTo="language-selector-mobile__transition--leave-to"
                    >
                        <Menu.Items className="language-selector-mobile__items">
                            <div className="language-selector-mobile__items-content">
                                {languages.map((x, index) => (
                                    <Menu.Item key={index}>
                                        {({ active }) => (
                                            <a
                                                href={x.value}
                                                className={`language-selector-mobile__item-button ${active ? 'language-selector-mobile__item-button--active' : ''}`}
                                            >
                                                {
                                                    x.imageUrl && <img src={x.imageUrl} alt="" width={24} height={24}/>
                                                }
                                                <span>{x.extendedText}</span>
                                            </a>
                                        )}
                                    </Menu.Item>
                                ))}
                            </div>
                        </Menu.Items>
                    </Transition>
                </>
            )}
        </Menu>
    </div>);
};

export default LanguageSelectorMobile;
